const SearchIcon = ({ className }: { className: string }) => {
  return (
    <svg viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M18.1257 19.5L13.1453 14.303M13.1453 14.303C14.4933 12.8964 15.2505 10.9887 15.2505 8.99949C15.2505 7.01029 14.4933 5.10256 13.1453 3.69599C11.7973 2.28941 9.96908 1.49921 8.06277 1.49921C6.15645 1.49921 4.32822 2.28941 2.98025 3.69599C1.63228 5.10256 0.875 7.01029 0.875 8.99949C0.875 10.9887 1.63228 12.8964 2.98025 14.303C4.32822 15.7096 6.15645 16.4998 8.06277 16.4998C9.96908 16.4998 11.7973 15.7096 13.1453 14.303V14.303Z" stroke="#7D7D7D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default SearchIcon
